export const ACTIONS = {
	RESET: 'RESET' as const,
	SET_ALL: 'SET_ALL' as const,
	SET_CELLS: 'SET_CELLS' as const,
	SET_COLUMNS: 'SET_COLUMNS' as const,
	SET_COUNT: 'SET_COUNT' as const,
	SET_ROWS: 'SET_ROWS' as const,
};
